(() => {
  try {
    const productHandle = window.theme?.productHandle

    if (!productHandle) return

    const key = 'theme:recently-viewed-products'

    const recentlyViewed = new Set(
      JSON.parse(localStorage.getItem(key) || '[]'),
    )

    // Remove current product first so it can be re-added at the top
    recentlyViewed.delete(productHandle)

    // Add current product
    recentlyViewed.add(productHandle)

    // Persist back in reverse order (most recent first)
    localStorage.setItem(key, JSON.stringify(Array.from(recentlyViewed).reverse()),
    )
  } catch (e) {
    // Fail silently
  }
})()
